import { createSelector } from "reselect";
import * as R from "ramda";
import * as routeDetailModel from "../../models/routeDetail";
import { getCurrentUser } from "./user";
import { getDriverRoutes, getRoutesList } from "./routes";
import { isDeferredRequest } from "../../features/routeDetail/model";

export const getRoute = (state) => state.route;

export const isCurrentUserLock = createSelector(
  getRoute,
  ({ currentUserLock }) => currentUserLock
);

export const isScheduleRequired = createSelector(
  getRoute,
  ({ scheduleRequired }) => scheduleRequired
);

export const getRequestOrder = createSelector(
  getRoute,
  ({ requestOrder }) => requestOrder
);

export const isSaveRouteEnabled = createSelector(
  getRoute,
  ({ saveRouteEnable }) => saveRouteEnable
);

export const getInitialDowngradeAttempts = createSelector(
  getRoute,
  ({ initialDowngradeAttempts }) => initialDowngradeAttempts
);

export const getRouteDetail = createSelector(getRoute, ({ routeDetail }) =>
  routeDetailModel.sortRouteStops(routeDetail)
);

export const getRouteStops = createSelector(getRouteDetail, ({ stop }) => stop);

export const getDeliveryRouteStops = createSelector(
  getRouteStops,
  routeDetailModel.getDeliveryRouteStops
);

export const getRouteTransferredStops = createSelector(
  getRouteDetail,
  ({ transferredStop = [] }) => transferredStop
);

export const isRouteReadyOrOpen = createSelector(
  getRouteDetail,
  (routeDetail) =>
    routeDetailModel.isRouteStatusReady(routeDetail) ||
    routeDetailModel.isRouteStatusOpen(routeDetail)
);

export const isRouteStatusLoading = createSelector(
  getRouteDetail,
  routeDetailModel.isRouteStatusLoading
);

export const isRouteStatusInBuild = createSelector(
  getRouteDetail,
  routeDetailModel.isRouteStatusInBuild
);

export const getCurrentRouteId = createSelector(
  getRoute,
  ({ routeDetail }) => routeDetail?.routeId
);

export const isDefaultRoute = createSelector(
  getCurrentRouteId,
  getRoutesList,
  routeDetailModel.isDefaultRoute
);

export const getOriginalRouteDetail = createSelector(
  getRoute,
  ({ originalRouteDetail }) => originalRouteDetail
);

export const isCurrentRouteHasRequestWithoutResponse = createSelector(
  getRouteDetail,
  (routeDetail) =>
    R.pathOr([], ["request"], routeDetail).some(
      (item) =>
        !item.response && item.routeId === R.path(["routeId"], routeDetail)
    )
);

export const hasRouteUnprocessedRequest = createSelector(
  getRouteDetail,
  (routeDetail) =>
    R.pathOr([], ["request"], routeDetail).some(
      (request) => !request.response || isDeferredRequest(request)
    )
);

export const getRouteRequests = createSelector(
  getRouteDetail,
  ({ request = [] }) => request
);

export const formatRouteDetailData = createSelector(
  getRouteDetail,
  isScheduleRequired,
  getCurrentUser,
  getInitialDowngradeAttempts,
  routeDetailModel.formatRouteDetailData
);

export const getTransferRouteId = createSelector(
  getRoute,
  ({ transferRouteId }) => transferRouteId
);

export const isTransferRouteDefault = createSelector(
  getTransferRouteId,
  getRoutesList,
  routeDetailModel.isDefaultRoute
);

export const getTransferRouteCode = createSelector(
  getTransferRouteId,
  getRoutesList,
  (routeId, routes) => {
    return routes[routeId]?.routeCode || routeId;
  }
);

export const getTransferFromRouteId = createSelector(
  getRoute,
  ({ transferFromRouteId }) => transferFromRouteId
);

export const getRouteLockedBy = createSelector(
  getDriverRoutes,
  getRouteDetail,
  (routes, route) => routeDetailModel.getRouteLockedBy(routes, route?.routeId)
);
